import { View, ViewStyle } from 'react-native';

import colors from 'config/colors';
import { RemakeOrderDescription } from 'modules/OverviewScene/components';
import { useAppSelector } from 'store/hooks';
import { Order } from 'store/Orders/types';
import { SettingSelectors } from 'store/Settings';
import { UserSelectors } from 'store/User';
import { CloseButton, Text } from 'components';

type Props = {
  order?: Order;
  style?: ViewStyle;
  onClose?: () => void;
};

export function Header({ order, style, onClose }: Props) {
  const featureFlags = useAppSelector(UserSelectors.selectFeatureFlags);
  const { shouldDisplayCustomerName } = useAppSelector(
    SettingSelectors.selectItemDetailsInterfaceSettings,
  );

  return (
    <View
      style={[
        {
          alignItems: 'center',
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          flexDirection: 'row',
          justifyContent: 'space-between',
          padding: 8,
          paddingHorizontal: 12,
        },
        style,
      ]}
    >
      {order ? (
        <Text color={'white'} size={24} font={'bold'}>
          #
          {[
            order.description,
            featureFlags.display_customer_address &&
              shouldDisplayCustomerName &&
              order.recipient.full_name,
          ]
            .filter((line) => !!line)
            .join('  -  ')}{' '}
          {order.remake_for_order_uuid &&
            order.remake_for_order_description && (
              <RemakeOrderDescription
                description={order.remake_for_order_description}
                color={colors.brightBeige}
              />
            )}
        </Text>
      ) : (
        <View />
      )}
      <CloseButton onPress={onClose} color={order ? 'white' : undefined} />
    </View>
  );
}
